module.exports = __webpack_public_path__ + "static/og-bc9fa928153826083195d82f83b97b84.png";